import React from 'react';
import { FormGroup, TextArea } from '@blueprintjs/core';
import { ErrorMessage } from 'formik';
import ErrorWrapper from 'components/forms/components/error-wrapper';

const FormTextAreaGroup = props => (
  <FormGroup
    inline={false}
    label={props.label}
    labelFor="text-area"
    labelInfo={props.requiredLabel && '(required)'}
    className={props.class || ''}
  >
    <TextArea
      id="text-area"
      onChange={props.handleChange}
      onBlur={props.handleBlur}
      name={props.name}
      value={props.value}
      leftIcon={props.leftIcon}
      placeholder={props.placeholder}
      fill={true}
      style={props.style}
      maxLength={500}
      minLength={1}
    />
    <ErrorMessage
      name={props.name}
      render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
    />
  </FormGroup>
);

export default FormTextAreaGroup;
